import * as React from 'react';
import Table from '@mui/material/Table';
import StatusBadge from '../statusBadge/StatusBadge';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

type RulesTableProps = {
    data: any[];
    headers:any[];
  };
  const RulesTable: React.FC<RulesTableProps>=({data,headers})=> {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Analytics Dashboard"
  return (
    <TableContainer  component={Paper} sx={{ paddingTop: '5rem', position:"relative",fontWeight:"bold" , borderRadius:"10px",boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)"}}>
        <Typography variant="h6" fontWeight="medium" sx={{position:"absolute",left:"20px", top:"30px"}}> {translate(TranslationEnum.analytics_dashboard,"Rules")}</Typography>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
          {headers.map((header) => (
              <TableCell key={header} sx={{ color: 'grey', fontWeight: 'bold'}} align="center">
                {translate(TranslationEnum.analytics_dashboard,header)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
            >
              <TableCell align="center" component="th" scope="row">
              {translate(TranslationEnum.analytics_dashboard,"General")}
              </TableCell>
              <TableCell align="center"> {translate(TranslationEnum.analytics_dashboard,row.name)}</TableCell>
              <TableCell align="center" sx={{ textTransform: "uppercase" }}><StatusBadge content={row.status} /></TableCell>
              <TableCell align="center"> {new Date(row.executionTime).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              })}</TableCell>
              <TableCell align="center"> {row.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default RulesTable